/* eslint-disable react/forbid-component-props */
import React, { useState, useEffect } from 'react'
import { PropTypes } from 'prop-types'
import { Container, Typography, Box, LinearProgress } from '@mui/material'
import { Link as NavigateLink } from 'react-router-dom'
import GuideLayout from './GuideLayout'
import { useAuth } from '../../../contexts/AuthContext'
import { Link } from 'react-router-dom'


import IntroductionChapter from './Pages/IntroductionChapter'

const ListItem = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <Box sx={{ height: '100%' }}>
        <Typography>{'\u2022' + ' '}</Typography>
      </Box>
      <Typography>{children}</Typography>
    </Box>
  )
}

ListItem.propTypes = {
  children: PropTypes.node,
}

const Introduction = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const { currentUser, db } = useAuth()

  console.log(currentUser)

  useEffect(() => {
    setUser(currentUser)
    setLoading(false)
  }, [currentUser])

  return (
    <section>
      <Container fixed sx={{ marginTop: '50px' }}>
        <Typography mb={6} variant="h4">
          Training Guide
        </Typography>
        <NavigateLink to="/members">{'< Back to Members Area'}</NavigateLink>
        <Box sx={{ marginTop: 5 }}>
          {!!loading && <LinearProgress color="primary" />}
          <GuideLayout watermark={`Licensed to ${user?.firstName} ${user?.lastName}`}>
            <Box>
              <Typography fixed align="center" mb={3}>
                PADs In Training Guide
              </Typography>
              <Typography variant="h4" align="center" mb={3}>
                Table of Contents
              </Typography>
         
              <Box component="ul" sx={{ pl: 3, listStyle: 'none', p: 0, m: 0, mb: 5 }}>
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#intro">
                    Introduction
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#process">
                    PADs In Training Process
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#members">
                    Becoming Fully Trained Registered Members
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#how-to-guide">
                    How to Use the Guide
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#other-dogs">
                    Recognising Other Types of Assistance Dogs
                  </a>
                </li>
              </Box>
            </Box>
            <IntroductionChapter />
          </GuideLayout>
        </Box>
      </Container>
    </section>
  )
}

export default Introduction
